<template>
  <div class="container d-flex justify-content-center">
    <div class="card flex-grow-1" style="max-width: 700px">
      <div class="card-body">
        <div v-if="active_tab === `login`">
          <p class="h4 mb-4 text-center">Sign in</p>
          <hr />
          <div class="px-4 pb-2">
            <input-control v-model="email" placeholder="E-mail" type="email" />
            <input-control v-model="password" placeholder="Password" type="password" />
            <input-control v-model="remember_me" label="Remember Me" type="checkbox" />

            <div class="text-center my-4">
              <tooltip v-if="!login_valid">
                <div v-if="email.length < 3">
                  {{ tr(`Enter your email to continue.`) }}
                </div>
                <div v-else-if="password.length === 0">
                  {{ tr(`Enter your password to continue`) }}
                </div>
                <div v-else>
                  {{
                    tr(`Enter your password to continue. If your password is less than 6 characters you will need
                    to reset it before signing in`)
                  }}
                </div>
              </tooltip>
              <loading-button :disabled="!login_valid" :method="login" text="Sign In" />
            </div>

            <div class="text-center">
              <p>
                Not a member?
                <span class="text-primary cursor-pointer" @click="active_tab = `register`"
                  >Register</span
                >
              </p>
              <p>
                Forgot your password?
                <span class="text-primary cursor-pointer" @click="active_tab = `forgot_password`"
                  >Reset Password</span
                >
              </p>
            </div>
          </div>
        </div>

        <div v-else-if="active_tab === `register`">
          <p class="h4 mb-4 text-center">Register</p>
          <hr />
          <div class="mt-4 text-center">
            If you are a staff member, DO NOT register a new account here. Instead, have someone at
            your store set up a staff account for you.
          </div>
          <div class="px-4 pb-2">
            <input-control v-model="user_name" placeholder="Name" type="text" />
            <input-control v-model="store" placeholder="Store" type="text" />
            <input-control v-model="email" placeholder="E-mail" type="email" />
            <input-control v-model="password" placeholder="Password" type="password" />
            <input-control
              v-model="password_confirm"
              placeholder="Confirm Password"
              type="password"
            />

            <div class="d-flex justify-content-between">
              <div>
                <input-control v-model="remember_me" label="Remember Me" type="checkbox" />
              </div>
              <div>
                <input-control type="layout">
                  <span class="text-primary cursor-pointer" @click="active_tab = `forgot_password`"
                    >Forgot Password?
                  </span>
                </input-control>
              </div>
            </div>

            <div class="text-center my-4">
              <loading-button :disabled="!register_valid" :method="register" text="Register" />
            </div>

            <div class="text-center">
              <p>
                Already registered?
                <span class="text-primary cursor-pointer" @click="active_tab = `login`"
                  >Sign In</span
                >
              </p>
            </div>
          </div>
        </div>
        <div v-else-if="active_tab === `forgot_password`">
          <p class="h4 mb-4 text-center">Forgot Password</p>
          <hr />
          <div class="px-4 pb-2">
            <div class="text-center pt-2">
              <p>
                Enter your email below - if an account with this email exists you will be sent
                instructions on how to reset your password.
              </p>
            </div>

            <input-control v-model="email" placeholder="E-mail" type="email" />

            <div class="text-center py-4">
              <loading-button
                :disabled="email.length <= 3"
                :method="reset_password"
                text="Reset Password"
              />
            </div>
            <div class="text-right">
              <span class="text-primary cursor-pointer" @click="active_tab = `login`"
                >Back to Sign In</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { tr } from '~/assets/scripts/helpers'

  export default {
    emits: ['logged-in'],
    data() {
      return {
        active_tab: 'login',
        remember_me: false,
        user_name: '',
        store: '',
        email: '',
        password: '',
        password_confirm: '',
      }
    },
    computed: {
      login_valid() {
        return this.email.length >= 3 && this.password.length >= 6
      },
      register_valid() {
        return (
          this.email.length >= 3 &&
          this.password.length >= 8 &&
          this.password_confirm === this.password &&
          this.user_name.length >= 3 &&
          this.store.length >= 2
        )
      },
    },
    methods: {
      tr,
      async login() {
        const resp = await $api('/api/account/login', {
          method: 'POST',
          body: { email: this.email, password: this.password, remember: this.remember_me },
        })
        this.$userStore.setUser(resp)
        this.$emit('logged-in')
      },
      async reset_password() {
        const resp = await $api('/api/account/request-password-reset', {
          method: 'POST',
          body: { email: this.email },
        })
        if (resp.success) {
          this.$toast.success(resp.success)
        }
      },
      async register() {
        const resp = await $api('/api/account/register', {
          method: 'POST',
          body: {
            email: this.email,
            password: this.password,
            name: this.user_name,
            store: this.store,
            remember: this.remember_me,
          },
        })
        this.$userStore.setUser(resp)
        this.$router.push('/account')
      },
    },
  }
</script>

<style scoped></style>
